export default {
    getStatusColor: (status) => {
        let green = ["Accepted", "Accepted with Revision"];
        let red = ["Rejected", "Rejected with Revision"];
        let yellow = ["Unassigned", "More Reviews", "Under Review"];

        if(green.includes(status)) return '#5AD14F';
        if(red.includes(status)) return '#FF4F4F';
        if(yellow.includes(status)) return '#E3D344';
        
        return "black"; //default to black
    },
    needsReupload: (status) => {
        if(status == "Accepted with Revision" || status == "Rejected with Revision")
            return true
        return false
    },
    changeLog: (status,reviewer) =>{
       return {
            'create': {
                'label': 'Paper created!',
            },
            'disableEdit': {
                'label': 'Submission Deadline ended. Cannot edit paper anymore'
            },
            'statusChanged':{
                'label': 'Paper status changed: ' + status
            },
            'reviewerAssigned':{
                'label': 'Reviewer assigned'
            },
            'newReview':{
                'label': 'New review uploaded by ' + reviewer
            },
            'trackReview':{
                'label': 'Full revision uploaded'
            },
            'reuploaded':{
                'label': 'Paper has been re-uploaded'
            },
            'needsReupload':{
                'label':'Paper needs to be re-uploaded'
            }
        }
    }
}